import React from "react";

import { faMinusCircle, faPlusCircle } from "@awesome.me/kit-4c83d50d0d/icons/classic/light";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import styles from "./Counter.module.css";

type CounterProps = {
	count: number;
	maximum?: number;
	minimum?: number;
	onChange: (count: number) => void;
};

export default function Counter(props: CounterProps) {
	const { count, maximum = Infinity, minimum = 0 } = props;

	function change(e: React.SyntheticEvent<HTMLInputElement, Event>) {
		let newCount = parseInt(e.currentTarget.value);
		if (isNaN(newCount) || newCount < 0) newCount = minimum;
		newCount = Math.max(Math.min(newCount, maximum), minimum);
		props.onChange(newCount);
	}

	function increment() {
		if (count < maximum) props.onChange(count + 1);
	}

	function decrement() {
		const newCount = props.count - 1;
		if (newCount > minimum) props.onChange(newCount);
	}

	return (
		<div className={styles.counter}>
			<div className={styles.counterButton} onClick={decrement}>
				<FontAwesomeIcon icon={faMinusCircle}></FontAwesomeIcon>
			</div>

			<input
				type="number"
				value={count === 0 ? "" : count}
				max={maximum}
				min={minimum}
				onChange={change}
				className={styles.counterInput}
			/>

			<div className={styles.counterButton} onClick={increment}>
				<FontAwesomeIcon icon={faPlusCircle}></FontAwesomeIcon>
			</div>
		</div>
	);
}
